export const apiBaseAddress = 'https://www.bp18.hu:8000' //prod
// export const apiBaseAddress = 'https://webteszt.bp18app.hu:8000' //test
export const apiAddress = apiBaseAddress + '/webapi'

export const devApiAddress = 'https://webteszt.bp18.hu:8000/webapi'
export const selfAddress = process.env.SELF_ADDRESS || apiAddress

export const partnerApiAddress = 'https://bp18app.hu' //prod
// export const partnerApiAddress = 'https://teszt.bp18app.hu' //test

export const isDevServer = process.env.NODE_ENV !== 'production'

export const server = isDevServer ? devApiAddress : selfAddress
export const partnerServer = isDevServer ? devApiAddress : partnerApiAddress
export const serverForImages = apiBaseAddress
export const serverForCityCardArticleImages = isDevServer
  ? 'https://teszt.bp18app.hu'
  : partnerApiAddress

export const NotFoundPage404 = '/'

export const version = '1.6'
